var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5012 12.0365V24.0985L19.9359 20.3592V12.0365C19.9359 7.65486 16.3836 4.10253 12.0001 4.10253C7.61663 4.10253 4.06616 7.65486 4.06616 12.0365C4.06616 16.4181 7.61848 19.9723 12.0001 19.9723C14.1234 19.9723 16.0522 19.1393 17.4758 17.7806L19.9359 20.3592C17.8719 22.3269 15.0786 23.5394 12.0001 23.5394C5.64888 23.5394 0.499023 18.3896 0.499023 12.0365C0.499023 5.6834 5.64888 0.5354 12.0001 0.5354C18.3514 0.5354 23.5012 5.68525 23.5012 12.0365Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1878 10.7643C7.1878 9.95353 7.84509 9.29624 8.6559 9.29624C9.46671 9.29624 10.124 9.95353 10.124 10.7643V12.0365C10.124 12.8473 9.46671 13.5046 8.6559 13.5046C7.84509 13.5046 7.1878 12.8473 7.1878 12.0365V10.7643Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1805 9.29624C13.3697 9.29624 12.7124 9.95353 12.7124 10.7643V12.0365C12.7124 12.8473 13.3697 13.5046 14.1805 13.5046C14.9913 13.5046 15.6486 12.8473 15.6486 12.0365V10.7643C15.6486 9.95353 14.9913 9.29624 14.1805 9.29624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAva);
export default __webpack_public_path__ + "static/media/IconAva.ff0436d050ce1babf5ff53d9facda242.svg";
export { ForwardRef as ReactComponent };